// frontend/src/components/admin/AdminNavbar.js
import React, { useState } from 'react';
import { 
  AppBar, 
  Tabs, 
  Tab, 
  Toolbar, 
  Typography, 
  Button,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { 
  VpnKey as KeyIcon,
  AccountBalance as GovernmentIcon,
  Article as ArticleIcon
} from '@mui/icons-material';

const AdminNavbar = ({ onTabChange = () => {} }) => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    console.log('Tab selected:', newValue);
    
    // Immediately update the value to move the red line
    setValue(newValue);
    
    // Trigger onTabChange to update parent component's state
    onTabChange(newValue);
    
    // Navigate based on selected tab
    switch(newValue) {
      case 0:
        navigate('/admin/government-interests');
        break;
  
      case 1:
        navigate('/admin/functional-keys');
        break;
      case 2:
        navigate('/admin/article-management');
        break;
      default:
        navigate('/admin-dashboard');
    }
  };

  const handleLogout = () => {
    // Clear token and redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('loginMode');
    navigate('/login');
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Admin Dashboard
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Tabs 
            value={value} 
            onChange={handleChange} 
            textColor="inherit"
            indicatorColor="secondary"
          >
            <Tab icon={<GovernmentIcon />} label="Government Interests" />
            <Tab icon={<KeyIcon />} label="Functional Keys" />
            <Tab icon={<ArticleIcon />} label="Article Management" />
          </Tabs>
          <Button color="inherit" onClick={handleLogout} sx={{ ml: 2 }}>
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminNavbar;